import React from 'react'
import { Box } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { Texts } from '../../../pure-js/libs/Texts'
import { getGrooverText } from '../libs/GrooverTextRepository'
import { ActivityRegistrationStatus } from '../../../pure-js/types/GrooverTypes'
import styled from '@emotion/styled'

interface Props {
  registrationStatus: ActivityRegistrationStatus
}

const getBadgeStyles = (status: ActivityRegistrationStatus) => {
  if (status === ActivityRegistrationStatus.Full) {
    return {
      background: '#ef233c', // vibrant red
      color: '#fff'
    }
  }
  // Closed
  return {
    background: '#f87171', // lighter red
    color: '#fff'
  }
}

const BadgeContainer = styled(Box)<{ bgcolor: string }>`
  display: flex;
  align-items: center;
  background: ${(props) => props.bgcolor};
  border-radius: 999px;
  padding: 2px 8px 2px 5px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  gap: 5px;
  min-width: 48px;
`

const IconCircle = styled(Box)`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 3px;
`

const ActivityStatusBadge: React.FC<Props> = ({ registrationStatus }) => {
  let textKey = Texts.adminGeneralEnumsEnrollmentStatusEnrollmentStatusClosed
  if (registrationStatus === ActivityRegistrationStatus.Full) {
    textKey = Texts.adminGeneralEnumsEnrollmentStatusEnrollmentStatusFull
  }
  const { background, color } = getBadgeStyles(registrationStatus)

  return (
    <BadgeContainer bgcolor={background} style={{ color }}>
      <IconCircle>
        <CloseIcon style={{ color: '#ef233c', fontSize: 12, fontWeight: 900 }} />
      </IconCircle>
      {getGrooverText(textKey)}
    </BadgeContainer>
  )
}

export default ActivityStatusBadge
